module.exports = __webpack_public_path__ + "img/initial.152e076d.svg";